import { useEffect, useRef, useState } from "react";

const questions = [
  "What services do you offer?", "Transportation Services", "Cargo Solutions", "Aircraft Spare Parts",
  "Cross-Border Transactions", "Import Services", "Manufacturing", "Which countries do you serve?",
  "How can I request a quotation?", "How do I contact FinFlux?", "Do you provide worldwide shipping?",
  "Are your products certified?", "What industries do you work with?", "Can I customize my order?", "How long does delivery take?",
];

const whatsappUrl = "https://wa.me/923339100197?text=Hello%20FinFlux%20Ventures%20%26%20Patners.%20I%20would%20like%20to%20know%20more%20about%20your%20services.";

const replies = {
  "what services do you offer?": "FinFlux provides Transportation, Cargo Solutions, Aircraft Spare Parts, Cross-Border Transactions, Import Services and Manufacturing solutions for aviation and industrial sectors.",
  "transportation services": "Our transportation services provide reliable air logistics, freight movement, cargo coordination and efficient supply chain management.",
  "cargo solutions": "We provide secure air cargo services, warehouse coordination, shipment tracking and international freight management.",
  "aircraft spare parts": "We supply certified aircraft spare parts, aviation equipment and genuine components sourced from trusted global partners.",
  "cross-border transactions": "We help businesses manage international trade, logistics, documentation and customs coordination efficiently.",
  "import services": "Our import services include procurement, supplier coordination, customs documentation and global freight solutions.",
  manufacturing: "We provide precision manufacturing solutions for aviation and industrial sectors with strict quality standards.",
  "which countries do you serve?": "We currently serve Pakistan, Saudi Arabia, United States and Canada while supporting international business partnerships.",
  "how can i request a quotation?": "You can request a quotation by filling out our Contact Form or chatting with our support team on WhatsApp.",
  "how do i contact finflux?": "You can contact us through our Contact page, Email, Phone or WhatsApp.",
  "do you provide worldwide shipping?": "Yes. We support worldwide logistics and international shipping depending on the product and destination.",
  "are your products certified?": "Yes. Our aviation products and spare parts are sourced according to international quality standards.",
  "what industries do you work with?": "We work with Aviation, Logistics, Manufacturing, Transportation and International Trade industries.",
  "can i customize my order?": "Yes. Depending on the product or service, customized solutions are available for business requirements.",
  "how long does delivery take?": "Delivery time depends on destination, customs clearance and product availability. Our team always aims for timely delivery.",
};

export default function ChatWidget() {
  const [open, setOpen] = useState(false);
  const [input, setInput] = useState("");
  const [typing, setTyping] = useState(false);
  const [messages, setMessages] = useState([
    { from: "bot", text: "👋 Hello! Welcome to FinFlux. I’m your virtual aviation assistant. Ask me anything, or pick a question below." },
  ]);
  const bodyRef = useRef(null);
  const timerRef = useRef(null);

  useEffect(() => {
    bodyRef.current?.scrollTo({ top: bodyRef.current.scrollHeight, behavior: "smooth" });
  }, [messages, typing]);
  useEffect(() => () => window.clearTimeout(timerRef.current), []);

  const respond = (question) => {
    const trimmed = question.trim();
    if (!trimmed || typing) return;
    setInput("");
    setMessages((current) => [...current, { from: "user", text: trimmed }]);
    setTyping(true);
    timerRef.current = window.setTimeout(() => {
      const normalized = trimmed.toLowerCase().replace(/[^a-z0-9\s?]/g, "").replace(/\s+/g, " ").trim();
      let answer = replies[normalized];

      if (!answer) {
        if (/\b(hello|hi|hey|salam|assalam)\b/.test(normalized)) {
          answer = "Hello! I’m the FinFlux AI Assistant. I can help with aviation, cargo, spare parts, imports, manufacturing, quotations, and contact information.";
        } else if (/\b(quote|quotation|price|pricing|cost|estimate)\b/.test(normalized)) {
          answer = replies["how can i request a quotation?"];
        } else if (/\b(whatsapp|phone|contact|call|email)\b/.test(normalized)) {
          answer = "You can reach FinFlux Ventures & Patners on WhatsApp at +92 333 9100197, or send an inquiry through our Contact page.";
        } else if (/\b(cargo|freight|shipment|shipping|warehouse)\b/.test(normalized)) {
          answer = replies["cargo solutions"];
        } else if (/\b(spare|parts|component|equipment)\b/.test(normalized)) {
          answer = replies["aircraft spare parts"];
        } else if (/\b(import|customs|procurement|supplier)\b/.test(normalized)) {
          answer = replies["import services"];
        } else if (/\b(manufactur|engineering|production)\b/.test(normalized)) {
          answer = replies.manufacturing;
        } else if (/\b(country|countries|location|serve|office)\b/.test(normalized)) {
          answer = replies["which countries do you serve?"];
        } else if (/\b(service|offer|help|solution)\b/.test(normalized)) {
          answer = replies["what services do you offer?"];
        } else if (/\b(thank|thanks)\b/.test(normalized)) {
          answer = "You’re welcome! If you need anything else, ask me here or continue with our team on WhatsApp.";
        } else {
          answer = "I can help with FinFlux services, cargo, aircraft parts, imports, manufacturing, worldwide delivery, quotations, and contact details. For a tailored answer, continue on WhatsApp and our team will assist you.";
        }
      }
      setMessages((current) => [...current, { from: "bot", text: answer }]);
      setTyping(false);
    }, 1000);
  };

  return (
    <div className="ff-support" id="ffSupport">
      <div className={`ff-chat-panel${open ? " open" : ""}`} id="chatBox" role="dialog" aria-modal="false" aria-labelledby="ff-chat-title" aria-hidden={!open}>
        <div className="ff-chat-header">
          <div className="ff-chat-id">
            <span className="ff-chat-avatar"><img loading="lazy" decoding="async" src="/assets/logo.webp" alt="FinFlux" /></span>
            <div className="ff-chat-id-text"><h3 id="ff-chat-title">FinFlux AI Assistant</h3><span className="ff-chat-status"><i className="ff-dot" />Online • Aviation Support</span></div>
          </div>
          <button type="button" className="ff-chat-close" aria-label="Close chat" onClick={() => setOpen(false)}><i className="fa-solid fa-xmark" /></button>
        </div>
        <div className="ff-chat-body" ref={bodyRef}>
          {messages.map((message, index) => (
            <div className={`ff-msg ff-msg-${message.from}`} key={`${message.from}-${index}`}>
              {message.from === "bot" && <span className="ff-msg-avatar"><img loading="lazy" decoding="async" src="/assets/logo.webp" alt="" /></span>}
              <div className="ff-msg-bubble">{message.text}</div>
            </div>
          ))}
          {messages.length === 1 && <div className="ff-quick-faqs">{questions.map((question) => <button type="button" className="ff-faq-chip" key={question} onClick={() => respond(question)}>{question}</button>)}</div>}
          {typing && <div className="ff-msg ff-msg-bot"><span className="ff-msg-avatar"><img loading="lazy" decoding="async" src="/assets/logo.webp" alt="" /></span><div className="ff-msg-bubble ff-typing"><span /><span /><span /></div></div>}
        </div>
        <div className="ff-chat-footer">
          <div className="ff-chat-inputbar">
            <input className="ff-chat-input" placeholder="Type your message..." autoComplete="off" value={input} onChange={(event) => setInput(event.target.value)} onKeyDown={(event) => { if (event.key === "Enter") respond(input); }} />
            <button type="button" className="ff-send-btn" aria-label="Send message" onClick={() => respond(input)}><i className="fa-solid fa-paper-plane" /></button>
          </div>
          <a className="ff-whatsapp-cta" href={whatsappUrl} target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-whatsapp" /> Continue on WhatsApp · +92 333 9100197</a>
        </div>
      </div>
      <div className="ff-support-buttons">
        <a href={whatsappUrl} className="ff-support-btn ff-whatsapp-btn" target="_blank" rel="noopener noreferrer" aria-label="Chat on WhatsApp at +92 333 9100197"><i className="fa-brands fa-whatsapp" /></a>
        <button type="button" className={`ff-support-btn ff-chat-btn${open ? " chat-open" : ""}`} aria-label="Open FinFlux AI Assistant" aria-expanded={open} aria-controls="chatBox" onClick={() => setOpen((current) => !current)}>
          <i className={`fa-solid ${open ? "fa-xmark" : "fa-comments"}`} />
          {!open && <span className="ff-chat-badge">AI</span>}
        </button>
      </div>
    </div>
  );
}
